<template>
  <div class="downloadAndroidAppModal">
    <div class="close-btn">
      <div class="cancel-btn" @click="close">
        <img style="width: 40px;"
             src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzOCAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTguOTk2IDQuNzEyODlDMTEuMTEzNCA0LjcxMjg5IDQuNzEyODkgMTEuMTEzMyA0LjcxMjg5IDE4Ljk5NjZDNC43MTI4OSAyNi44Nzk5IDExLjExMzQgMzMuMjgwMyAxOC45OTYgMzMuMjgwM0MyNi44ODEgMzMuMjgwMyAzMy4yNzkzIDI2Ljg3OTkgMzMuMjc5MyAxOC45OTY2QzMzLjI3OTMgMTEuMTEzMyAyNi44ODEgNC43MTI4OSAxOC45OTYgNC43MTI4OVpNMTguOTk2IDYuNjEyODlDMjUuODMxMyA2LjYxMjg5IDMxLjM3OTMgMTIuMTYxOCAzMS4zNzkzIDE4Ljk5NjZDMzEuMzc5MyAyNS44MzEzIDI1LjgzMTMgMzEuMzgwMyAxOC45OTYgMzEuMzgwM0MxMi4xNjA4IDMxLjM4MDMgNi42MTI4OSAyNS44MzEzIDYuNjEyODkgMTguOTk2NkM2LjYxMjg5IDEyLjE2MTggMTIuMTYwOCA2LjYxMjg5IDE4Ljk5NiA2LjYxMjg5WiIgZmlsbD0iI0Y2RDlBQSIgZmlsbC1vcGFjaXR5PSIwLjYiLz4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjUuNDUzMiAxMS4yMTA4TDExLjIyNDQgMjUuNDM5N0MxMC44NTM2IDI1LjgxMDUgMTAuODUzMiAyNi40MTIgMTEuMjI0NCAyNi43ODMyQzExLjU5NTUgMjcuMTU0MyAxMi4xOTcxIDI3LjE1NCAxMi41Njc5IDI2Ljc4MzJMMjYuNzk2OCAxMi41NTQzQzI3LjE2NzQgMTIuMTgzNyAyNy4xNjc5IDExLjU4MiAyNi43OTY4IDExLjIxMDhDMjYuNDI1NiAxMC44Mzk3IDI1LjgyMzkgMTAuODQwMiAyNS40NTMyIDExLjIxMDhaIiBmaWxsPSIjRjZEOUFBIiBmaWxsLW9wYWNpdHk9IjAuNiIvPg0KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNi43ODkyIDI1LjQzNDdMMTIuNTYwMyAxMS4yMDU4QzEyLjE4OTUgMTAuODM1IDExLjU4OCAxMC44MzQ3IDExLjIxNjggMTEuMjA1OEMxMC44NDU3IDExLjU3NyAxMC44NDYgMTIuMTc4NSAxMS4yMTY4IDEyLjU0OTNMMjUuNDQ1NyAyNi43NzgyQzI1LjgxNjMgMjcuMTQ4OCAyNi40MTggMjcuMTQ5MyAyNi43ODkyIDI2Ljc3ODJDMjcuMTYwMyAyNi40MDcxIDI3LjE1OTggMjUuODA1MyAyNi43ODkyIDI1LjQzNDdaIiBmaWxsPSIjRjZEOUFBIiBmaWxsLW9wYWNpdHk9IjAuNiIvPg0KPC9zdmc+DQo=">
      </div>
    </div>
    <div class="main-content">
      <div class="downloadImageWrapper">
        <img
          src="https://s3.ap-northeast-1.amazonaws.com/media.web.pgebet.com/home/downloadAndroidModal.png"
          @click="downloadApp"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {LogUtils} from '@/utils'

export default {
  name: 'downloadAndroidAppModal',
  props: ['handleClose'],
  data () {
    return {
    }
  },
  methods: {
    close () {
      this.handleClose()
    },
    downloadApp () {
      LogUtils.downloadApp('ClickTopDown')
    }
  }
}
</script>

<style lang="less" scoped>
  .downloadAndroidAppModal {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0,0,0,.6);
    z-index: 990;
    padding: 15vh 20px 40px;
    box-sizing: border-box;
    overflow: auto;
    background-position: bottom;
    background-origin: border-box;
    background-size: contain;
    background-repeat: no-repeat;
    display: flex;
    flex-flow: column;

    .main-content{
      width: 90%;
      align-self: center;

      .downloadImageWrapper {
        width:100%;
        img {
          width:100%;
        }
      }
    }

    .close-btn {
      width: 100%;
      height: 40px;

      .cancel-btn {
        width: 38px;
        height: 38px;
        margin: 0  0 10px auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DownloadAndroidAppModal/index.vue